export var ErrorCode = /*#__PURE__*/function (ErrorCode) {
  ErrorCode["NO_ACCOUNT"] = "NO_ACCOUNT";
  ErrorCode["ACCOUNT_EXISTS"] = "ACCOUNT_EXISTS";
  ErrorCode["INVALID_PASSWORD"] = "INVALID_PASSWORD";
  ErrorCode["EXCLUDED_PASSWORD"] = "EXCLUDED_PASSWORD";
  /**
   * When shipping country is invalid to purchasing items
   */
  ErrorCode["INVALID_SHIPPING_COUNTRY"] = "INVALID_SHIPPING_COUNTRY";
  /**
   * Attempted pw recovery in anonymous mode without recovery code.
   */
  ErrorCode["RECOVERY_CODE_MISSING"] = "RECOVERY_CODE_MISSING";
  /**
   * Attempted pw recovery in anonymous mode with a recovery code that was either invalid format or not found in db.
   */
  ErrorCode["RECOVERY_CODE_INVALID"] = "RECOVERY_CODE_INVALID";
  /**
   * Request failed due to db transaction failure.
   */
  ErrorCode["DB_TRANSACTION_FAILED"] = "DB_TRANSACTION_FAILED";
  /**
   * Login was blocked since device requires authentication.
   */
  ErrorCode["REQUIRES_DEVICE_AUTHENTICATION"] = "REQUIRES_DEVICE_AUTHENTICATION";
  ErrorCode["SAME_PASSWORD"] = "SAME_PASSWORD";
  ErrorCode["TOKEN_EXPIRED"] = "TOKEN_EXPIRED";
  ErrorCode["TOKEN_MISSING"] = "TOKEN_MISSING";
  ErrorCode["INVALID_SESSION"] = "INVALID_SESSION";
  /**
   * When User's time deviates from Server's time more than a threshold.
   */
  ErrorCode["USER_TIME_DEVIATION"] = "USER_TIME_DEVIATION";
  return ErrorCode;
}(ErrorCode || {});